












































import Vue from 'vue';
import textFieldDefaultProps from '@/tools/helpers/textFieldDefaultProps';
import formValidationRules from '@/tools/validationRules/formValidationRules';
import ApiRequest from '../../tools/ApiRequest';
import RequestException from '../../tools/helpers/RequestException';
import TMAlert from '../../tools/models/TMAlert';

export default Vue.extend({
  name: 'forgotPassword',
  data: () => ({
    state: false,
    isFormValid: false,
    email: '',
    textFieldProps: textFieldDefaultProps,
    validationRules: formValidationRules,
  }),
  computed: {
    form(): Vue & { validate: () => boolean } {
      return this.$refs.form as Vue & { validate: () => boolean };
    },
  },
  methods: {
    show(): void {
      this.state = true;
    },
    close(): void {
      this.email = '';
      this.state = false;
    },
    submit(): void {
      if (this.form.validate()) {
        ApiRequest.passwordReset(this.email)
          .then(() => {
            this.$store.dispatch(
              'setAlert',
              new TMAlert({
                title: 'Alteração de senha',
                message: 'Verifique seu e-mail para realizar a alteração da senha.',
                state: true,
              }),
            );

            this.$router.push('/login');
          })
          .catch((error) => new RequestException(error, this.$store, this.$router));
      }
    },
  },
});
